// extracted by mini-css-extract-plugin
export default {"comment":"CommentItem_comment__X-FLY","name":"CommentItem_name__+doST","inscription":"CommentItem_inscription__JNOtd","rating":"CommentItem_rating__W+oiK"};